import React from "react";
import _ from "lodash";
import { DateTime } from "luxon";
import { toast } from "react-toastify";

export const validateFerrySearch = (values, showToast = true) => {
  const error_msgs = [];
  if (_.isEmpty(values.origin)) {
    error_msgs.push(["origin", "Please select an origin."]);
  }
  if (_.isEmpty(values.destination)) {
    error_msgs.push(["destination", "Please select a destination."]);
  }
  if (!values.departDateTime?.[0]) {
    error_msgs.push(["departDateTime", "Please select departure datetime"]);
  }
  if (values.isRoundtrip && !values.returnDateTime?.[0]) {
    error_msgs.push(["date", "Please select return date"]);
  }
  if (values.isRoundtrip && values.returnDateTime[0]) {
    const date1 = DateTime.fromISO(values.departDateTime[0]);
    const date2 = DateTime.fromISO(values.returnDateTime[0]);
    if (date2 < date1) {
      error_msgs.push([
        "date",
        "Please select a return date after departure date",
      ]);
    }
  }

  if (error_msgs.length && showToast) {
    toast.warning(
      <ul>
        {error_msgs.map((msg, idx) => (
          <li key={idx}>{msg[1]}</li>
        ))}
      </ul>,
      { duration: 5000 }
    );
  }

  return Boolean(error_msgs.length);
};
